<template>
  <div class="norms__group">
    <div class="norms__header">{{ group.name }}</div>
    <div class="norms__elements">
      <div v-for="(nutrient, key) in group.nutrients" :key="key" class="norms__element">
        <div class="norms__element-name">
          <Tooltip v-if="nutrient?.tooltip" placement="top">
            <template #trigger>
              <span class="norms__element-name-tooltip">{{ nutrient.name }}</span>
            </template>
            <span class="norms__element-name-tooltip-content">{{ nutrient.tooltip }}</span>
          </Tooltip>
          <template v-else>{{ nutrient?.name ?? "" }}</template>
        </div>
        <div class="norms__element-data">
          <div class="norms__element-calculated">
            <div class="norms__element-measurement">
              <template v-if="nutrientsMap[key].measurement">
                ({{ nutrientsMap[key].measurement }}
                )
              </template>
            </div>
            <div class="norms__element-calculated-value">{{ calculatedNorm(key) }}</div>
          </div>
          <div class="norms__element-inputed">
            <BaseInputNumber
              v-if="canEdit"
              :test-id="`DietDetailAssumptions__Norms__${group.name}`"
              class="norms__element-input"
              :disabled="key === 'glycemic_index' || key === 'glycemic_load'"
              :min="0"
              :max="nutrient?.maxValue"
              :precision="precision"
              :step="step"
              :model-value="inputedNorm(key)"
              @update:model-value="emit('update', key, $event)"
            />
            <div v-else class="norms__element-dummy" @click="emit('upgrade')">
              {{ calculatedNorm(key) }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
  import BaseInputNumber from '@/components/BaseInputNumber.vue'
  import { Tooltip } from '@/components/ui'
  import { normsAssumptions } from '@/utils/norms'
  import { nutrientsMap } from '@/utils/nutrients'

  import type { Nutrients } from '@/utils/nutrients'

  defineProps<{
    calculatedNorm: (key: Nutrients) => number | 'b.d.'
    canEdit: boolean
    group: (typeof normsAssumptions)[number]
    inputedNorm: (key: Nutrients) => number
    precision: number
    step: number
  }>()
  const emit = defineEmits<{
    update: [key: Nutrients, value: number]
    upgrade: []
  }>()
</script>
